/**
 * A draft-safe attachment is one that has been fully uploaded to the server:
 * it has a real id (not undefined/null/0) and is neither errored nor mid-upload.
 * Transient FileManager entries must never be persisted into a draft.
 *
 * @param {Object} attachment
 * @returns {boolean}
 */
const isDraftSafeAttachment = attachment => {
  const id = attachment?.id;

  return (
    id !== undefined &&
    id !== null &&
    id !== 0 &&
    id !== '0' &&
    !attachment?.hasError &&
    !attachment?.isLoading
  );
};

/**
 * Filters an attachments array down to the ones safe to persist into a draft.
 *
 * @param {Object[]} attachments
 * @returns {Object[]}
 */
export const normalizeDraftSafeAttachments = attachments =>
  (attachments ?? []).filter(isDraftSafeAttachment);
